<app-ds-checkbox [label]="checkboxLabel" [checked]="checkboxChecked" (clicked)="onToggleOptional()"></app-ds-checkbox>
<div *ngIf="checkboxChecked" class="ds-form-row" [class.has-error]="hasError">
  <label class="ds-label">{{ title }}</label>
  <div class="chips">
    <ng-container *ngFor="let chip of chips">
      <app-ds-chip [active]="chip.id === value" [value]="chip.id" (check)="onCheck($event)">{{ chip.option_text }}</app-ds-chip>
    </ng-container>
    <div *ngIf="hasError" class="ds-input-error">{{'GROW.riskProfile.profile.errors.requiredSelect' | translate}}</div>
  </div>
</div>
